module.exports = __webpack_public_path__ + "img/convert-to-case-inactive.6f06a360.svg";